import { render, staticRenderFns } from "./RecipientPicker.vue?vue&type=template&id=0cd69c40&"
import script from "./RecipientPicker.vue?vue&type=script&lang=ts&"
export * from "./RecipientPicker.vue?vue&type=script&lang=ts&"
import style0 from "./RecipientPicker.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports